import helper from "./helper"

const getMendeleevUrlWithParameters = helper.getMendeleevUrlWithParameters

export default {
  SELECTORS: {
    EDUCATION_DIRECTION:
      (gets = null) => getMendeleevUrlWithParameters(
        'selectors|references|directions',
        'get',
        {},
        gets
      ),
    EDUCATION_PROFILE:
      (gets = null) => getMendeleevUrlWithParameters(
        'selectors|references|profiles',
        'get',
        {},
        gets
      ),
    OLYMPIADS:
      (gets = null) => getMendeleevUrlWithParameters(
        'selectors|references|olympiads',
        'get',
        {},
        gets
      ),
    REGIONS:
      (gets = null) => getMendeleevUrlWithParameters(
        'selectors|references|regions',
        'get',
        {},
        gets
      ),
    PARTNERS_TAGS:
      (gets = null) => getMendeleevUrlWithParameters(
        'selectors|partners|tags',
        'get',
        {},
        gets
      ),
    PARTNERS_REGIONS:
      (gets = null) => getMendeleevUrlWithParameters(
        'selectors|references|regions',
        'get',
        {},
        gets
      ),
    EVENTS_TAGS:
      (gets = null) => getMendeleevUrlWithParameters(
        'selectors|events|tags',
        'get',
        {},
        gets
      ),
  },
}
